import React from 'react';

const Experience = () => {
  return (
    <section id="experience" className="section">
      <div className="container">
        <h2 className="section-title">Work Experience</h2>
        <div className="experience-timeline">
          <div className="experience-card">
            <div className="experience-header">
              <h3 className="experience-title">Digital Marketing Lead</h3>
              <span className="experience-duration">Current</span>
            </div>
            <div className="experience-company">Ayham Netfaji</div>
            <ul className="experience-tasks">
              <li>Lead digital marketing strategies and campaigns</li>
              <li>Develop data-driven marketing solutions</li>
              <li>Create scalable digital growth frameworks</li>
              <li>Integrate marketing with development projects</li>
            </ul>
          </div>
          
          <div className="experience-card">
            <div className="experience-header">
              <h3 className="experience-title">Web Developer</h3>
              <span className="experience-duration">2 months</span>
            </div>
            <div className="experience-company">RD Infro Technology</div>
            <ul className="experience-tasks">
              <li>Built a fully responsive landing page in modern design using HTML, CSS, and JavaScript</li>
              <li>Designed modern UI with mobile-first approach</li>
              <li>Implemented interactive calculator functionality</li>
              <li>Improved page performance and accessibility standards</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;